export default "__VITE_ASSET__Dy9WsN9g__"